import { SERVER_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: SERVER_MNG,
  params: null,
  formatData(data) {
    let configArr = []
    if (data.specServerConfigDTOList?.length) {
      configArr = configArr.concat(data.specServerConfigDTOList)
    }
    if (data.gpuConfigDTOList?.length) {
      configArr = configArr.concat(data.gpuConfigDTOList)
    }
    if (configArr?.length) {
      data.specServerConfigDTOList = configArr
    }
    return data
  },
  cb() {
    const model = this.formRef.model
    if (model.specServerConfigDTOList?.length) {
      const cpuArr = []
      const gpuArr = []
      model.specServerConfigDTOList.forEach(item => {
        if (item.configKey == 'CPU') {
          cpuArr.push(item)
        }
        if (item.configKey == 'GPU') {
          gpuArr.push(item)
        }
      })
      model.specServerConfigDTOList = null
      cpuArr?.length && (model.specServerConfigDTOList = cpuArr)
      gpuArr?.length && (model.gpuConfigDTOList = gpuArr)
    }
  },
  view: {
    title: '创建服务器',
    labelPosition: 'right',
    labelWidth: '170px',
    width: '700px',
    content: [
      {
        $id: 'serverName',
        $type: 'input',
        label: '服务器型号',
        $el: {
          placeholder: '请输入服务器型号',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '服务器型号'
          }
        ]
      },
      {
        $id: 'serverDesc',
        $type: 'input',
        $el: {
          type: 'textarea',
          rows: 5
        },
        label: '服务器描述',
        rules: [
          {
            notEmpty: '服务器描述'
          }
        ]
      },
      {
        $id: 'type',
        $type: 'select',
        label: '服务器类型',
        $el: {
          placeholder: '请输入服务器类型',
          suffixIcon: 'el-icon-edit',
          filterable: true
        },
        $options: [
          {
            label: 'VDI',
            value: 'VDI'
          },
          {
            label: 'IDV',
            value: 'IDV'
          },
          {
            label: 'MINI',
            value: 'MINI'
          }
        ],
        rules: [
          {
            notEmpty: 'type'
          }
        ]
      },
      {
        $id: 'cpu',
        $type: 'input',
        label: 'CPU描述',
        $el: {
          placeholder: '请输入cpu详细描述',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        }
      },
      {
        $id: 'specServerMemoryConfigDTOList',
        $type: 'sky-server-memory-config',
        label: '内存配置',
        $el: {
          configKey: 'MEMORY',
          configValueOnePlaceholder: '单CPU内存条规则',
          configValueTwoPlaceholder: '双CPU内存条规则',
          configValueOneRequired: true,
          configValueTwoRequired: true
        }
      },
      {
        $id: 'specServerConfigDTOList',
        $type: 'sky-server-config',
        label: 'CPU灵活配置详细信息',
        $el: {
          configValueTwoType: 'number',
          configValueThreeType: 'number',
          configValueFourType: 'number'
        }
      },
      {
        $id: 'gpuConfigDTOList',
        $type: 'sky-server-config',
        label: 'GPU配置',
        $el: {
          configKey: 'GPU',
          configValueOnePlaceholder: '厂商',
          configValueTwoPlaceholder: '型号',
          configValueThreePlaceholder: '单CPU支持张数',
          configValueFourPlaceholder: '双CPU支持张数',
          configValueThreeRequired: false,
          configValueFourRequired: false
        }
      },
      {
        $id: 'memory',
        $type: 'input',
        label: '内存信息',
        $el: {
          placeholder: '请输入内存信息',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: '内存信息'
          }
        ]
      },
      {
        $id: 'diskInfo',
        $type: 'input',
        label: '磁盘信息',
        $el: {
          placeholder: '请输入磁盘信息',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: '磁盘信息'
          }
        ]
      },
      {
        $id: 'nicsInfo',
        $type: 'input',
        label: '网卡信息',
        $el: {
          placeholder: '请输入网卡信息',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: '网卡信息'
          }
        ]
      }
    ]
  }
}
